import { createContext, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import ROUTE from 'src/utils/routeConstants';
import useReportJobs from '../hooks/useReportJobs';
import useReportWorkspace from '../hooks/useReportWorkspace';

const ReportingContext = createContext(null);
export const ReportingProvider = ({ activeView, children }) => {
  const history = useHistory();
  const jobs = useReportJobs(Boolean(activeView));
  const reports = useReportWorkspace(activeView === 'reports', jobs.upsertJob);
  const analytics = useReportWorkspace(activeView === 'analytics', jobs.upsertJob);
  const workspaces = { reports, analytics };
  const navigate = (target) => history.push(target === 'reports' ? ROUTE.tyreV2Reports : ROUTE.tyreV2Analytics);
  const transfer = (source, target, vehicleId = '') => {
    const current = workspaces[source];
    if (!current.report) return;
    workspaces[target].adoptReport({
      report: current.report, job: current.viewedReport?.job,
      filters: current.appliedFilters, vehicleId,
    });
    navigate(target);
  };
  return <ReportingContext.Provider value={{ ...jobs, workspaces, transfer, navigate }}>{children}</ReportingContext.Provider>;
};
export const useReporting = () => useContext(ReportingContext);
